export enum FeedType {
  common = 'common',
  user = 'user',
}
